import { useState, useEffect } from 'react'
import PriceComponent from '../Price'
import Map from '../EventMap'
import styles from './ContentArea.module.scss'

export default function ContentArea({
  title,
  content,
  titleType = 'h2',
  anchor = false,
  price = false,
  map = false,
  isCollapsible = false,
  children,
}) {
  const [isCollapsed, setIsCollapsed] = useState(isCollapsible)

  const getContentClass = () => {
    if (isCollapsed) {
      return `${styles.content} ${styles.collapsed}`
    }

    return styles.content
  }

  const toggleCollapsibles = (e) => {
    e.preventDefault()
    setIsCollapsed(!isCollapsed)
  }

  // Reset collapse states when component remounts.
  useEffect(() => {
    setIsCollapsed(isCollapsible)
  }, [content])

  return (
    <section className={styles.section} id={anchor || null}>
      <header>
        {titleType === 'h1' && <h1 className={styles.title}>{title}</h1>}
        {titleType !== 'h1' && <h2 className={styles.title}>{title}</h2>}

        {price && <PriceComponent price={price} />}
      </header>

      <div
        className={getContentClass()}
        dangerouslySetInnerHTML={{ __html: content }}
      />
      {isCollapsible && (
        <div className={styles.readMoreWrap}>
          <a
            className={styles.readMore}
            href="#"
            onClick={(e) => toggleCollapsibles(e)}
          >
            {isCollapsed ? 'Lue lisää' : 'Näytä vähemmän'}
            <img
              className={isCollapsed ? styles.arrowUp : styles.arrowDown}
              src="/img/arrow-down-pink.svg"
              width="14"
              height="14"
              loading="lazy"
              alt=""
              role="presentation"
            />
          </a>
        </div>
      )}

      {map && <Map map={map} />}

      {children && children}
    </section>
  )
}
